import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from 'environments/environment';
/* import * as Sentry from '@sentry/angular'; */

import { AppModule } from 'app/app.module';
import '@gamelearn/skeletor/dist/cjs/index';

declare global {
  interface Window {
    toggleTranslations: any;
  }
}

// eslint-disable-next-line
console.log('Gamelearn Services Platform', environment.version);

/* if (environment.sentry.show) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.environment,
  });
  // window.Sentry = Sentry; // Smartlook integration needs it
} */

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

function toggleTranslations(lang) {
  const debugLang = sessionStorage.getItem('debug_lang');

  if (debugLang && !lang) {
    console.info('㊗️㊗️㊗️ Exiting translations debug mode ㊗️㊗️㊗️');
    sessionStorage.removeItem('debug_lang');
  } else {
    lang = lang || 'labels';
    console.info('㊗️㊗️㊗️ Entering translations debug mode with lang: ' + lang + ' ㊗️㊗️㊗️');
    sessionStorage.setItem('debug_lang', lang);
  }
  location.reload();
}

window.toggleTranslations = toggleTranslations;
